export enum Errors {
    CANT_CONNECT = -1, // ошибка подключения
    CANT_CONNECT_0 = 0, // ошибка подключения
    BAD_REQUEST = 400, // ошибка с входящими данными
    PASSWORD_REQUIRED = 401, // необходимо авторизоваться
    RECONNECTION_NOT_POSSIBLE = 4001, // невозможно выполнить переподключение
    NEED_UPDATE_CLIENT = 4002, // необходимо обновить клиент
    EMPTY_LOGIN = 4003, // пустой логин
    UNKNOWN_SEX = 4004, // неизвестный пол
    LOGIN_IS_USED = 4005, // логин уже используется
    MESSAGE_TO_UKNOWN_USER = 4006, // сообщение неизвестному пользователю
    MESSAGE_IS_EMPTY = 4007, // пустое сообщение
    UNKNOWN_MESSAGE_TYPE = 4008, // неизвестный тип сообщ
    WRONG_PASSWORD = 4009, // неправильный пароль
    USER_IS_BLOCKED = 4010, // юзер заблокирован
    LOGIN_TOO_LONG = 4011, // юзер заблокирован
    MESSAGE_TO_LONG = 4012, // сообщение слишком длинное
    TOO_MANY_CHATS_CREATED_BY_USER = 4013, // сообщение слишком длинное
    ROOM_WITH_NAME_ALREADY_EXIST = 4014, // комната с таким именем уже существует
    ROOM_CREATING_ONLY_FOR_REGISTERED = 4015, // создание комнат только для зарегистрированных
    CAN_ENTER_ONLY = 4016, // войти могут только ...
    MESSAGE_BLOCKED = 4017, // сообщение заблокировано
    TO_MANY_MESSAGES = 4018, // сообщение заблокировано
    ENTER_ALLOWED_ONLY_TO_REGISTERED = 4019, // вход в комнату разрешен только зарегистрированным
    RECAPTHCA_FAILURE = 4020, // юзер провалил прохождение рекапчи
    TO_MANY_IMAGES_IN_MAIN_CHAT = 4021, // слишком много картинок отослано в главный чат
    NOT_ENOUGH_TIME_AFTER_LOGIN = 4022, // слишком мало времени прошло после входа в чат
    SEVERAL_LANGUAGES_IN_LOGIN = 4023, // русские и английские буквы одновременно в логине
    VPN_DETECTED = 4024, // подозрение на впн
    EMAIL_INCORRECT = 4025, // неверный емеил
    PASSWORD_TOO_SHOR = 4026, // пароль слишком короткий
    PASSWORD_TOO_LONG = 4027, // пароль слишком длинный
    PASSWORD_ONLY_FROM_DIGITS = 4028, // пароль содержит только цифры
    EMAIL_IS_BUSY = 4029, // почта уже используется
    EMAIL_OR_CODE_IS_WRONG = 4030, // email или hash неверный при подтверждении почты
    RESTORE_DATA_IS_WRONG = 4031, // вышло время ожидания для восстановления пароля
    RESTORE_CODE_LINK_EXPIRE = 4032, // вышло время ожидания для восстановления пароля
    EMAIL_NOT_CONFIRMED = 4033, // почта не подтверждена
    UNKNOWN_USER_OR_EMAIL_CONFIRMED = 4034, // пользователь не найден или почта уже подтверждена
    DELAY_BEFORE_CONFIRMATION_SENT = 4035, // необходимо еще подождать перед повторной отправкой письма
    SPACES_NOT_ALLOWED_IN_LOGIN = 4036, // запрещено использовать пробел в логине
    ENTERS_ATTEMPTS_EXCEEDED = 4037, // исчерпано количество попыток входа
    DELAY_BEFORE_RESTORATION_SENT = 4038, // необходимо еще подождать перед повторной отправкой письма восстановления
    INCORRECT_SYMBOLS_IN_LOGIN = 4039, // некорректные символы в логине
    PASSWORDS_NOT_EQUALS = 4040, // пароли не совпадают
    TO_MANY_ATTEMPTS_TO_CHANGE_PASSWORD = 4041, // слишком много попыток сменить пароль
    GENDER_WAS_CHANGED_RECENTLY = 4042, // пол был уже изменен недавно
    NO_PRIVILEGES_FOR_THIS = 4043, // нет прав на совершение действия
    YOU_DISALLOW_PRIVATE_MESSAGES = 4044, // вы запретили отправку приватных сообщений
    USER_DISALLOW_PRIVATE_MESSAGES = 4045, // пользователь запретили отправку приватных сообщений
    TOO_MANY_REGISTRATIONS = 4046, // слишком много попыток отправить почту (зарегистрироваться) с одного email-а
    KICKED_FROM_ROOM = 4047, // вход в комнату запрещен модераторами
    USER_NOT_FOUND = 4048, // пользователь не найден
    USER_NOT_PREMIUM = 4049, // пользователь не имеет премиум статуса
    USER_BANNED = 4050, // пользователь находится в бане
    USER_ALREADY_ROOM_MODERATOR = 4051, // пользователь уже является модератором комнаты
    USER_NOT_A_ROOM_MODERATOR = 4052, // пользователь не является модератором комнаты
    OTHER_INCORRECT_SYMBOLS_IN_LOGIN = 4053, // некорректные символы в логине (которіе невидны)
    AMOUNT_TO_SMALL = 4054, // сума слишком маленькая
    AMOUNT_TO_HIGH = 4055, // сума слишком большая
    PAYMENT_INITIALIZATION_ERROR = 4056, // ошибка при инициализации платежа
    PAYMENT_ERROR = 4057, // ошибка проведения платежа
    NOT_ENOUGH_MONEY = 4058, // недостаточно денег
    ROOM_NOT_PAID = 4059, // комната не оплачена
    BUY_PREMIUM_DISABLED = 4060, // покупка премиума отключена
    PREMIUM_ONLY_FOR_REGISTERED = 4061, // покупка премиума только для зарегистрированных
    FAVORITES_LIMIT_EXCEEDED = 4062, // достигнут лимит избранных
    FAVORITES_GUEST_REQUIRES_PREMIUM = 4063, // добавление гостевых записей доступно только при активном Премиуме
    FAVORITES_ALREADY_EXISTS = 4064, // пользователь уже в избранном
    FAVORITES_CANNOT_ADD_SELF = 4065, // нельзя добавить самого себя в избранное
    FAVORITES_ONLY_FOR_REGISTERED = 4066, // функционал доступен только зарегистрированным пользователям
    AVATAR_TOKEN_RATE_LIMITED = 4067, // превышен лимит запросов токена на загрузку аватара
    AVATAR_INVALID_HASH = 4068, // некорректный формат хэша аватара
    AVATAR_RATE_LIMITED = 4069, // слишком частая смена аватара
    TELEGRAM_ONLY_FOR_REGISTERED = 4070, // пополнение через Telegram Stars доступно только зарегистрированным пользователям
    TELEGRAM_STARS_DISABLED = 4071, // оплата Telegram Stars отключена на этом инстансе чата
    TELEGRAM_PACKAGE_NOT_FOUND = 4072, // пакет пополнения не найден (прайс-лист изменился)
    STOP_WORD_TOO_SHORT = 4073, // стоп-слово короче 3 символов
    STOP_WORD_CONTAINS_LINK = 4074, // стоп-слово содержит http
    STOP_WORD_ALREADY_EXISTS = 4075, // такое стоп-слово уже есть
    STOP_WORD_NOT_FOUND = 4076, // стоп-слово не найдено
    STOP_WORD_COMMENT_REQUIRED = 4077, // при удалении стоп-слова обязателен комментарий
    ABOUT_TOO_LONG = 4078, // текст "о себе" длиннее допустимого
    ABOUT_CONTAINS_LINK = 4079, // в тексте "о себе" есть ссылка
    ABOUT_FORBIDDEN_CONTACT = 4080, // в тексте "о себе" есть запрещённый telegram-ник
    BIRTH_DATE_INVALID = 4081, // некорректная дата рождения (или возраст вне 18..99)
    BIRTH_DATE_CHANGED_RECENTLY = 4082, // дата рождения менялась меньше суток назад
    PROFILE_RATE_LIMITED = 4083, // слишком частое изменение профиля
    SEX_NOT_ALLOWED_IN_CURRENT_ROOM = 4084, // новый пол не пускают в одну из комнат, где пользователь сейчас находится
    BAN_REASON_TITLE_ALREADY_EXISTS = 4085, // причина бана с таким названием уже есть в этой комнате
    SERVER_ERROR = 500, // что-то пошло не так на сервере
}

export function getMessageIdByError(error: Errors): string {
    switch (error) {
        case Errors.CANT_CONNECT:
        case Errors.CANT_CONNECT_0:
            return 'error_connect'
        case Errors.SERVER_ERROR:
            return 'error_server'
        case Errors.UNKNOWN_SEX:
            return 'wrong_gender';
        case Errors.BAD_REQUEST:
            return 'unknown_error';
        case Errors.EMPTY_LOGIN:
            return 'login_too_short';
        case Errors.LOGIN_IS_USED:
            return 'login_is_used';
        case Errors.RECAPTHCA_FAILURE:
            return 'you_are_bot'
        case Errors.SEVERAL_LANGUAGES_IN_LOGIN:
            return 'error_en_ru_chars_together'
        case Errors.VPN_DETECTED:
            return 'error_vpn_used'
        case Errors.EMAIL_IS_BUSY:
            return 'email_is_busy'
        case Errors.EMAIL_OR_CODE_IS_WRONG:
            return 'email_or_code_is_wrong'
        case Errors.RESTORE_DATA_IS_WRONG:
            return 'restore_data_is_wrong'
        case Errors.RESTORE_CODE_LINK_EXPIRE:
            return 'restore_code_link_expire'
        case Errors.ROOM_CREATING_ONLY_FOR_REGISTERED:
            return 'room_creating_only_for_registered'
        case Errors.DELAY_BEFORE_CONFIRMATION_SENT:
            /*Наблюдаются проблемы с отправкой писем подтверждения. Подождите, немного и не забудьте проверить папку спам.*/
            return 'delay_before_confirmation_send'
        case Errors.SPACES_NOT_ALLOWED_IN_LOGIN:
            return 'spaces_not_allowed_in_login'
        case Errors.UNKNOWN_USER_OR_EMAIL_CONFIRMED:
            return 'unknown_user_or_email_confirmed'
        case Errors.EMAIL_NOT_CONFIRMED:
            return 'email_not_confirmed'
        case Errors.DELAY_BEFORE_RESTORATION_SENT:
            return 'delay_before_restoration_send'
        case Errors.WRONG_PASSWORD:
            return 'wrong_password'
        case Errors.USER_IS_BLOCKED:
            return 'user_is_blocked'
        case Errors.LOGIN_TOO_LONG:
            return 'login_too_long'
        case Errors.MESSAGE_TO_LONG:
            return 'message_to_long'
        case Errors.MESSAGE_BLOCKED:
            return 'message_blocked'
        case Errors.TO_MANY_MESSAGES:
            return 'to_many_messages'
        case Errors.TO_MANY_IMAGES_IN_MAIN_CHAT:
            return 'to_many_images_in_main_chat'
        case Errors.NOT_ENOUGH_TIME_AFTER_LOGIN:
            return 'not_enough_time_after_login'
        case Errors.TOO_MANY_CHATS_CREATED_BY_USER:
            return 'you_have_created_too_many_rooms'
        case Errors.ROOM_WITH_NAME_ALREADY_EXIST:
            return 'room_with_name_already_exist'
        case Errors.EMAIL_INCORRECT:
            return 'email_incorrect'
        case Errors.PASSWORD_TOO_SHOR:
            return 'password_to_short'
        case Errors.PASSWORD_TOO_LONG:
            return 'password_to_long'
        case Errors.PASSWORD_ONLY_FROM_DIGITS:
            return 'password_only_from_digits'
        case Errors.INCORRECT_SYMBOLS_IN_LOGIN:
            return 'incorrect_symbols_in_login'
        case Errors.OTHER_INCORRECT_SYMBOLS_IN_LOGIN:
            return 'other_incorrect_symbols_in_login'
        case Errors.PASSWORDS_NOT_EQUALS:
            return 'passwords_not_equals'
        case Errors.TO_MANY_ATTEMPTS_TO_CHANGE_PASSWORD:
            return 'too_many_attempts_to_change_password'
        case Errors.GENDER_WAS_CHANGED_RECENTLY:
            return 'gender_was_changed_recently'
        case Errors.NO_PRIVILEGES_FOR_THIS:
            return 'no_privileges'
        case Errors.YOU_DISALLOW_PRIVATE_MESSAGES:
            return 'you_disallow_private_messages'
        case Errors.USER_DISALLOW_PRIVATE_MESSAGES:
            return 'user_disallow_private_messages'
        case Errors.TOO_MANY_REGISTRATIONS:
            return 'too_many_registrations_from_ip'
        case Errors.KICKED_FROM_ROOM:
            return 'kicked_from_room_error'
        case Errors.USER_NOT_FOUND:
            return 'user_not_found'
        case Errors.USER_NOT_PREMIUM:
            return 'user_not_premium'
        case Errors.USER_BANNED:
            return 'user_banned'
        case Errors.USER_ALREADY_ROOM_MODERATOR:
            return 'user_already_moderator'
        case Errors.USER_NOT_A_ROOM_MODERATOR:
            return 'user_not_a_room_moderator'
        case Errors.AMOUNT_TO_SMALL:
            return 'amount_is_to_small'
        case Errors.AMOUNT_TO_HIGH:
            return 'amount_is_to_high'
        case Errors.PAYMENT_INITIALIZATION_ERROR:
            return 'payment_initialization_error'
        case Errors.PAYMENT_ERROR:
            return 'payment_error'
        case Errors.NOT_ENOUGH_MONEY:
            return 'not_enough_money'
        case Errors.ROOM_NOT_PAID:
            return 'room_not_paid'
        case Errors.BUY_PREMIUM_DISABLED:
            return 'buy_premium_disabled'
        case Errors.PREMIUM_ONLY_FOR_REGISTERED:
            return 'premium_only_for_registered'
        case Errors.FAVORITES_LIMIT_EXCEEDED:
            return 'favorites_limit_exceeded'
        case Errors.FAVORITES_GUEST_REQUIRES_PREMIUM:
            return 'favorites_guest_requires_premium'
        case Errors.FAVORITES_ALREADY_EXISTS:
            return 'favorites_already_exists'
        case Errors.FAVORITES_CANNOT_ADD_SELF:
            return 'favorites_cannot_add_self'
        case Errors.FAVORITES_ONLY_FOR_REGISTERED:
            return 'favorites_only_for_registered';
        case Errors.AVATAR_TOKEN_RATE_LIMITED:
            return 'avatar_token_rate_limited';
        case Errors.AVATAR_INVALID_HASH:
            return 'avatar_invalid_hash';
        case Errors.AVATAR_RATE_LIMITED:
            return 'avatar_rate_limited';
        case Errors.TELEGRAM_ONLY_FOR_REGISTERED:
            return 'telegram_only_for_registered';
        case Errors.TELEGRAM_STARS_DISABLED:
            return 'telegram_stars_disabled';
        case Errors.TELEGRAM_PACKAGE_NOT_FOUND:
            return 'telegram_package_not_found';
        case Errors.STOP_WORD_TOO_SHORT:
            return 'stop_word_too_short';
        case Errors.STOP_WORD_CONTAINS_LINK:
            return 'stop_word_contains_link';
        case Errors.STOP_WORD_ALREADY_EXISTS:
            return 'stop_word_already_exists';
        case Errors.STOP_WORD_NOT_FOUND:
            return 'stop_word_not_found';
        case Errors.STOP_WORD_COMMENT_REQUIRED:
            return 'stop_word_comment_required';
        case Errors.ABOUT_TOO_LONG:
            return 'about_too_long';
        case Errors.ABOUT_CONTAINS_LINK:
            return 'about_contains_link';
        case Errors.ABOUT_FORBIDDEN_CONTACT:
            return 'about_forbidden_contact';
        case Errors.BIRTH_DATE_INVALID:
            return 'birth_date_invalid';
        case Errors.BIRTH_DATE_CHANGED_RECENTLY:
            return 'birth_date_changed_recently';
        case Errors.PROFILE_RATE_LIMITED:
            return 'profile_rate_limited';
        case Errors.SEX_NOT_ALLOWED_IN_CURRENT_ROOM:
            return 'sex_not_allowed_in_current_room';
        case Errors.BAN_REASON_TITLE_ALREADY_EXISTS:
            return 'ban_reason_title_already_exists';
        default:
            return 'unknown_error';
    }
}
